export default __webpack_public_path__ + "static/media/book.0ec3f0f5.png";